import React, { useState, useEffect } from 'react'
import { Backdrop, CircularProgress, Typography } from '@mui/material'
import useStyles from './useStyle'
import SuscribersOfUsersTable from './TableNavigable/TableNavigable'
import { useParams } from 'react-router-dom'
import { getSubscriberUserCorpEntities } from '../../../app/services/Suscriber/getSubscriberUserCorpEntities'
import BreadcrumbsComponent from './Breadcrumbs/Breadcrumbs'
import { getUserLoginAccountWithID } from '../../../app/services/LoginAccount/getLoginAccountWithId'
import { useDispatch } from 'react-redux'
import { setErrorTextSnackBar } from '../../../redux/actions/app'
import {
  SnackBarError,
  SnackBarSuccess
} from '../../../components/SnackBars/SnackBars'
import InfoIcon from '@mui/icons-material/Info'

export const SuscribersOfUser = () => {
  const dispatch = useDispatch()
  const { id } = useParams()
  const classes = useStyles()
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [user, setUser] = useState(null)

  // buscar por id llogin account y mapear organizationuserids buscar suscritorp por userids
  const getUser = async () => {
    try {
      const response = await getUserLoginAccountWithID(id)
      setUser(response.data.loginAccount)
      return response.data.loginAccount
    } catch (error) {
      if (
        error.response?.data?.error?.message !== 'Verify LoginAccount email.'
      ) {
        // error
        // dispatch(setRequestTextSnackBar())
        dispatch(setErrorTextSnackBar('Ocurrió un error. Intente nuevamente'))
      }
      return null
    }
  }
  const getSubscribersWithUserID = async () => {
    try {
      const response = await getUser()
      if (
        response.organizationUsers &&
        response.organizationUsers?.length > 0
      ) {
        await handleGetSubscriber(response.organizationUsers)
      }
    } catch (error) {
      setRows([])
    }
  }

  const handleGetSubscriber = async (data) => {
    try {
      data.map(async (org) => await handlegetSubsRequest(org.userId))
    } catch (error) {}
  }

  const handlegetSubsRequest = async (userId) => {
    try {
      const response = await getSubscriberUserCorpEntities(userId)

      setRows((oldState) => oldState.concat(response.data))
    } catch (error) {
      if (
        error.response?.data?.message === 'Usuario no posee suscriptor asignado'
      ) {
        dispatch(setErrorTextSnackBar('Usuario no posee suscriptor asignado'))
      }
    }
  }

  useEffect(async () => {
    setLoading(true)
    setRows([])
    await getSubscribersWithUserID()
    setLoading(false)
  }, [id])

  return (
    <div className={classes.root}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <BreadcrumbsComponent
        name={user ? user.firstName + ' ' + user.lastName : ''}
      />
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>
          Suscriptores asociados a un usuario
        </Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon
          style={{ fontSize: '2rem', color: '#00a78f', marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          La siguiente lista muestra los suscriptores del usuario{' '}
          {user ? user.firstName + ' ' + user.lastName : ''}.
        </Typography>
      </div>

      <SnackBarSuccess />
      <SnackBarError />
      <div className={classes.boxTable}>
        <SuscribersOfUsersTable
          id={id}
          rows={rows}
          setRows={setRows}
          setLoading={setLoading}
        />
      </div>
    </div>
  )
}
